export default function reversePrints(){
    const prints = document.querySelector(".prints");

    if (prints.classList.contains("prints-reverse")) {
        prints.classList.remove("prints-reverse");
      } else {
        prints.classList.add("prints-reverse");
      }
  }